// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__4ORg_","copyright":"Footer_copyright__3sPuO"};